import React from 'react';
import { Nurse, ROLE_TYPES } from '../../types/nurse';
import AssignNurseDialogCommon from './AssignNurseDialogCommon';

interface AssignSupportNurseDialogProps {
  open: boolean;
  onClose: () => void;
  nurseId: number;
  onSuccess: () => void;
  nurse?: Nurse; // 一般看護師情報
}

const AssignSupportNurseDialog: React.FC<AssignSupportNurseDialogProps> = ({
  open,
  onClose,
  nurseId,
  onSuccess,
  nurse
}) => {
  const fixedNurseRoleLabel = (roleType: string) => {
    return ROLE_TYPES[roleType as keyof typeof ROLE_TYPES] || roleType;
  };
  const selectedNurseRoleLabel = (roleType: string) => {
    return ROLE_TYPES[roleType as keyof typeof ROLE_TYPES] || roleType;
  };
  return (
    <AssignNurseDialogCommon
      open={open}
      onClose={onClose}
      nurseId={nurseId}
      onSuccess={onSuccess}
      title="サポート看護師の登録"
      mode="support"
      fixedNurse={nurse || null}
      fixedNurseTitle="一般看護師"
      fixedNurseRoleLabel={fixedNurseRoleLabel}
      selectedNurseTitle="サポート看護師"
      selectedNurseRoleLabel={selectedNurseRoleLabel}
      searchPlaceholder="名前またはニックネームで検索"
      emptyMessage="条件に一致する上席看護師が見つかりませんでした"
      buttonText="登録"
      fixedNurseOnLeft={false}
    />
  );
};
export default AssignSupportNurseDialog;
